import React, { Component } from "react";
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselCaption
} from "reactstrap";

class Shots extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      enlarged: this.props.expand === true ? true : false,
      company: this.props.company
    };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.enlarge = this.enlarge.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  next() {
    if (this.animating) return;
    const nextIndex =
      this.state.activeIndex === this.props.items.length - 1
        ? 0
        : this.state.activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  }

  previous() {
    if (this.animating) return;
    const nextIndex =
      this.state.activeIndex === 0
        ? this.props.items.length - 1
        : this.state.activeIndex - 1;
    this.setState({ activeIndex: nextIndex });
  }

  enlarge() {
    this.setState({
      enlarged: !this.state.enlarged
    });
  }

  render() {
    const { activeIndex } = this.state;

    const slides = this.props.items.map(item => {
      return (
        <CarouselItem
          onExiting={this.onExiting}
          onExited={this.onExited}
          key={item.src}
        >
          <div className="md-block"></div>
          <CarouselCaption
            captionText={item.caption}
            captionHeader={item.header}
          />
          <img
            src={item.src}
            alt={item.altText}
            className={
              this.state.enlarged
                ? "enlarged"
                : "" || this.props.noStretch
                ? "noStrech"
                : ""
            }
          />
        </CarouselItem>
      );
    });

    return (
      <>
        <div style={{ textAlign: "center" }}>
          <a onClick={this.enlarge} style={{ cursor: "pointer" }}>
            {this.state.enlarged ? "➖Shrink" : "➕Enlarge"}
          </a>
        </div>
        <Carousel
          interval={false}
          activeIndex={activeIndex}
          next={this.next}
          previous={this.previous}
          slide={false}
        >
          {slides}
          <CarouselControl
            direction="prev"
            directionText="Previous"
            onClickHandler={this.previous}
          />
          <CarouselControl
            direction="next"
            directionText="Next"
            onClickHandler={this.next}
          />
        </Carousel>
      </>
    );
  }
}

export default Shots;
